import { QueryClient } from "@tanstack/react-query";

/** The one QueryClient, in a leaf module so the session guard and the stream can reach it. */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
